<template>
  <div class="relative">
    <div class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton"
        :color="navbarColorLocal"
        :class="textColor"
      >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer p-2"
          icon="MenuIcon"
          @click.stop="showSidebar"
        />

        <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />

        <vs-spacer />

        <vs-dropdown vs-trigger-click divider>
          <a class="flex items-center" href.prevent>
            {{name}}
            <i class="material-icons">expand_more</i>
          </a>
          <vs-dropdown-menu>
            <vs-dropdown-item style="width:190px;">
              <p
                class="text-sty"
                @click="activePrompt = true"
                style="color:#ff9f43;border-bottom:1px solid #f5f5f5;"
              >Modify Password</p>
            </vs-dropdown-item>
            <vs-dropdown-item>
              <p class="text-sty" style="color:#7367f0;" @click="eqit">Logout</p>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </vs-navbar>
    </div>

    <vs-popup @close="close" :active.sync="activePrompt" title="Modify Password">
      <div class="con-exemple-prompt">
        <vs-input
          type="password"
          placeholder="Old Password"
          vs-placeholder="Old"
          v-model="old"
          class="mt-3 w-full"
        />
        <vs-input
          type="password"
          placeholder="New Password"
          vs-placeholder="New"
          v-model="new1"
          class="mt-3 w-full"
        />
        <vs-input
          type="password"
          placeholder="New Password"
          vs-placeholder="New Again"
          v-model="new2"
          class="mt-3 w-full"
        />
        <p v-show="computedPass" style="color:#f00;font-size:12px;">Two passwords are inconsistent</p>
        <div class="flex flex-end mt-3">
          <vs-button :disabled="computedPass" @click="confirm" size="small">Confirm</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>


<script>
import Bookmarks from "./components/Bookmarks.vue"
import SearchBar from "./components/SearchBar.vue"
import NotificationDropDown from "./components/NotificationDropDown.vue"
import ProfileDropDown from "./components/ProfileDropDown.vue"

export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data () {
    return {
      activePrompt: false,
      old: "",
      new1: "",
      new2: "",
      name: ""
    }
  },
  components: {
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
  },
  computed: {
    computedPass () {
      return this.new1 != "" && this.new2 != "" && this.new1 !== this.new2;
    },
    navbarColorLocal () {
      return this.$store.state.theme === "dark" && this.navbarColor === "#fff" ? "#10163a" : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return { 'text-white': (this.navbarColor != '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor != '#fff' && this.$store.state.theme !== 'dark') }
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj () {
      if (this.verticalNavMenuWidth == "default") return "navbar-default"
      else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced"
      else if (this.verticalNavMenuWidth) return "navbar-full"
    },
  },

  created () {
    let user = localStorage.getItem('user');
    if (user) {
      let userInfo = JSON.parse(user);
      this.name = userInfo.name;
    }
  },
  methods: {
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
    },
    eqit () {
      this.$api.logout().then(res => {
        console.log(res);

        this.$vs.notify({
          color: "success",
          icon: 'check',
          text: res.data.message,
          position: "top-center"
        })
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        this.$router.push('/9nC7bAMYL3')
      })
    },
    confirm () {
      this.$api.updatePass({
        old_password: this.old,
        new_password: this.new1
      }).then(res => {
        console.log(res);
        if (res.data.code == 1159) {
          this.activePrompt = false;
          this.$vs.notify({
            color: "success",
            icon: 'check',
            text: res.data.message,
            position: "top-center"
          })
        } else {
          this.$vs.notify({
            color: "danger",
            icon: 'error',
            text: res.data.message,
            position: "top-center"
          })
        }

      })
    },
    close () {
      this.old = "";
      this.new1 = "";
      this.new2 = "";
    }
  }
}
</script>
<style lang="scss" scoped>
.text-sty {
  text-align: center;
  padding: 10px;

  &:hover {
    background-color: #f5f5f5;
  }
}
</style>

